/** Shared refusal identity for rules that cannot resolve from the held facts. Keep this leaf free of cast/runtime imports. */
export class HandBack extends Error {
  constructor(public readonly reason: string) { super(`hand-back: ${reason}`); }
}
export function handBack(reason: string): never { throw new HandBack(reason); }
